export default {
    nav: {
        brand: 'travellingdominika',
        services: 'Servizi',
        portfolio: 'Portfolio',
        contact: 'Contatti',
    },
    hero: {
        taglineLabel: 'QUI',
        taglineTitle: 'Dominika',
        taglineSubLine1: 'Content creator,',
        taglineSubLine2: 'che cattura l’attenzione.',
        socialsLabel: 'CONOSCIMI MEGLIO',
    },
    intro: {
        label: 'CHI SONO',
        greet: 'Ciao / hi!',
        title: 'Sono Dominika.',
        body1: 'Creo contenuti creativi, viaggio per il mondo, mi rilasso nella natura e catturo momenti speciali con l’obiettivo della mia macchina fotografica.',
        body2: 'Mi ispirano le nuove esperienze, i posti belli, le montagne e le persone interessanti.',
        expandCta: 'Conoscimi meglio',
        collapseCta: 'Chiudi',
        longBioLabel: 'LA STORIA PIÙ LUNGA',
        instagramTitle: 'Ultimo post su Instagram',
        longBio: [
            'Mi chiamo Dominika. Mi ispirano i viaggi frequenti, i nuovi luoghi, gli interni curati, la natura e la cucina.',
            'Per professione sono tecnica di radiologia, ma per passione e amore per la creatività sono diventata content creator e social media manager. Ho oltre 6 anni di esperienza nel marketing e nei social media.',
            'Lavoro come social media specialist in un’agenzia di marketing medico e collaboro con clienti e brand sviluppando i loro social media e creando contenuti.',
            'La parte preferita del mio lavoro è creare materiale per il mondo del turismo, dei viaggi e dell’hôtellerie. È un lavoro che mi riempie di energia positiva, adoro fermare i momenti, giocare con la luce e raccontare storie, emozioni e atmosfere attraverso la fotocamera.',
            'Affronto ogni progetto in modo completo, costruisco una mood map e cerco idee perché il messaggio risulti autentico.',
            'Scoprire nuovi posti è la mia grande passione, per questo ogni viaggio è un’avventura piena di ispirazione.',
            'Adoro la natura della Svizzera, vivo la dolce vita all’italiana, mi sono innamorata della cultura giapponese e apprezzo profondamente la cucina e la località della Polonia.',
            'Del mio lavoro amo che ogni giorno apre una nuova pagina che mi stimola creativamente.',
        ],
    },
    services: {
        label: 'SERVIZI',
        headlinePre: 'Due strade,',
        headlineItalic: 'per lavorare',
        headlinePost: 'insieme.',
        ugc: {
            tag: 'Content creation.',
            titlePre: 'Contenuti',
            titleItalic: 'creati con',
            titlePost: 'idea.',
            intro: 'Mostrami cosa rende speciale il tuo posto, io catturerò quella magia attraverso l’obiettivo.',
            body: 'Creo contenuti per hotel, città, regioni turistiche, attività locali, ristoranti, caffetterie e brand di prodotti.',
            stat: '60+',
            statLabel: 'clienti soddisfatti',
        },
        manage: {
            tag: 'Social Media Management.',
            titlePre: 'Gestisco',
            titleItalic: 'tutto il',
            titlePost: 'feed.',
            intro: 'Raccontami le esigenze del tuo business e mi occuperò dei tuoi social media a 360°.',
            body: 'Curo a tutto tondo i tuoi profili su Instagram, Facebook, LinkedIn e TikTok.',
            stat: '6+ anni',
            statLabel: 'di esperienza nei social media',
        },
    },
    pricing: {
        label: 'PACCHETTI',
        title: 'Pacchetti di esempio.',
        sub: 'Prezzi su misura, sono aperta a creare un’offerta personalizzata per te.',
        currency: 'CHF',
        from: 'Da',
        items: [
            {
                name: 'Fotografia',
                price: '600',
                bullets: [
                    'Pacchetto da 10–50 foto (numero da concordare) in alta qualità dopo l’editing',
                    'Le immagini sono per il tuo uso personale o aziendale',
                ],
            },
            {
                name: 'Instagram Foto',
                price: '1200',
                bullets: [
                    'Carosello creativo con 5–15 foto (numero da concordare)',
                    '1 reel oppure 1 pacchetto da 10 foto in alta qualità dopo l’editing',
                ],
            },
            {
                name: 'Instagram Video',
                price: '800',
                bullets: [
                    'Reel da 30–45 secondi (numero di reel da concordare)',
                ],
            },
            {
                name: 'Foto × Travellingdominika',
                price: '600',
                bullets: [
                    "Carosello creativo con 5–15 foto, in co-creazione con il mio account {'@'}travellingdominika",
                ],
            },
        ],
        footer: 'Ogni offerta è definita in modo individuale. Sono aperta a parlarne, scrivimi e costruiamo insieme qualcosa cucito su misura per te.',
    },
    realizations: {
        label: 'I MIEI PROGETTI',
        titlePre: 'Creo contenuti che',
        titleItalic: 'raccontano una storia',
        titlePost: 'e coinvolgono.',
        body: 'Del mio lavoro amo che ogni giorno apre una nuova pagina che mi stimola creativamente.',
        list: [
            { icon: 'camera', label: 'Fotografia' },
            { icon: 'film', label: 'Video brevi' },
            { icon: 'pen', label: 'Testi creativi' },
            { icon: 'pin', label: 'Press trip & storytelling di un luogo' },
            { icon: 'share', label: 'Gestione dei social media' },
        ],
        cards: [
            { title: 'Hotel' },
            { title: 'Turismo & viaggi' },
            { title: 'Cucina & ristoranti' },
            { title: 'Attività locali' },
            { title: 'Fotografia di prodotto' },
            { title: 'Moda' },
            { title: 'Outdoor' },
        ],
        prev: 'Indietro',
        next: 'Avanti',
    },
    stats: {
        label: 'IN NUMERI',
        title: 'Qualche anno a inseguire la luce.',
        sub: 'Non penso solo ai numeri, ma a contenuti di qualità che coinvolgono, qui però puoi vedere un po’ della mia esperienza.',
        items: [
            { value: '6+', label: 'Anni di esperienza', sub: 'in content creation e social media' },
            { value: '60+', label: 'Collaborazioni', sub: 'clienti, brand partner e progetti' },
            { value: '1 mln+', label: 'Reach', sub: "intorno a {'@'}travellingdominika" },
            { value: '30+', label: 'Paesi', sub: 'da cui ho preso ispirazione' },
        ],
    },
    portfolio: {
        label: 'PORTFOLIO',
        title: 'I posti in cui sono stata.',
        hint: 'trascina',
        galleryCta: 'Vedi tutta la galleria',
        items: [
            { title: 'Kyoto', place: 'Giappone' },
            { title: 'Bieszczady', place: 'Polonia' },
            { title: 'Harder Kulm', place: 'Svizzera' },
            { title: 'Grindelwald First', place: 'Svizzera' },
            { title: 'Gdańsk', place: 'Polonia' },
            { title: 'Lucerna', place: 'Svizzera' },
            { title: 'Como', place: 'Italia' },
            { title: 'Copenaghen', place: 'Danimarca' },
            { title: 'Berna', place: 'Svizzera' },
        ],
        closeLabel: 'Chiudi',
        prevLabel: 'Foto precedente',
        nextLabel: 'Foto successiva',
        photoCount: 'foto',
        backLabel: 'Indietro',
        categoryTaglines: {
            hotels: "hotel con cui ho collaborato",
            tourism: "posti in cui sono stata",
            products: "brand e prodotti che ho fotografato",
        },
        categoryLabels: {
            hotels: 'Hotel',
            tourism: 'Turismo',
            products: 'Servizi prodotto',
        },
        filterLabel: 'Mostra',
        filterAll: 'Tutto',
        albums: [
            {
                title: "Filario",
                place: "Lago di Como, Italia",
                category: "hotels",
                description: "Un design hotel sul Lago di Como — luce a pelo d'acqua, interni calmi e ampie vedute sul lago.",
                cover: '/portfolio/filario/1.jpg',
                photos: [
                    '/portfolio/filario/1.jpg',
                    '/portfolio/filario/2.jpg',
                    '/portfolio/filario/3.jpg',
                    '/portfolio/filario/4.jpg',
                    '/portfolio/filario/5.jpg',
                    '/portfolio/filario/6.jpg',
                    '/portfolio/filario/7.jpg',
                    '/portfolio/filario/8.jpg',
                    '/portfolio/filario/9.jpg',
                    '/portfolio/filario/10.jpg',
                    '/portfolio/filario/11.jpg',
                    '/portfolio/filario/12.jpg',
                    '/portfolio/filario/13.jpg',
                    '/portfolio/filario/14.jpg',
                    '/portfolio/filario/15.jpg',
                    '/portfolio/filario/16.jpg',
                    '/portfolio/filario/17.jpg',
                    '/portfolio/filario/18.jpg',
                    '/portfolio/filario/19.jpg',
                    '/portfolio/filario/20.jpg',
                    '/portfolio/filario/21.jpg',
                    '/portfolio/filario/22.jpg',
                    '/portfolio/filario/23.jpg',
                    '/portfolio/filario/24.jpg',
                    '/portfolio/filario/25.jpg',
                    '/portfolio/filario/26.jpg',
                    '/portfolio/filario/27.jpg',
                    '/portfolio/filario/28.jpg',
                    '/portfolio/filario/29.jpg',
                    '/portfolio/filario/30.jpg',
                    '/portfolio/filario/31.jpg',
                    '/portfolio/filario/32.jpg',
                    '/portfolio/filario/33.jpg',
                    '/portfolio/filario/34.jpg',
                    '/portfolio/filario/35.jpg',
                    '/portfolio/filario/36.jpg',
                    '/portfolio/filario/37.jpg',
                    '/portfolio/filario/38.jpg',
                    '/portfolio/filario/39.jpg',
                    '/portfolio/filario/40.jpg',
                    '/portfolio/filario/41.jpg',
                ],
            },
            {
                title: "Guesthouse Castagnola",
                place: "Castagnola, Lugano",
                category: "hotels",
                description: "Una guesthouse di charme a Castagnola sopra il Lago di Lugano — atmosfera mediterranea, camere accoglienti e giardini subtropicali.",
                cover: '/portfolio/guesthouse-castagnola/1.jpg',
                photos: [
                    '/portfolio/guesthouse-castagnola/1.jpg',
                    '/portfolio/guesthouse-castagnola/2.jpg',
                    '/portfolio/guesthouse-castagnola/3.jpg',
                    '/portfolio/guesthouse-castagnola/4.jpg',
                    '/portfolio/guesthouse-castagnola/5.jpg',
                    '/portfolio/guesthouse-castagnola/6.jpg',
                    '/portfolio/guesthouse-castagnola/7.jpg',
                    '/portfolio/guesthouse-castagnola/8.jpg',
                    '/portfolio/guesthouse-castagnola/9.jpg',
                    '/portfolio/guesthouse-castagnola/10.jpg',
                    '/portfolio/guesthouse-castagnola/11.jpg',
                    '/portfolio/guesthouse-castagnola/12.jpg',
                    '/portfolio/guesthouse-castagnola/13.jpg',
                    '/portfolio/guesthouse-castagnola/14.jpg',
                    '/portfolio/guesthouse-castagnola/15.jpg',
                    '/portfolio/guesthouse-castagnola/16.jpg',
                    '/portfolio/guesthouse-castagnola/17.jpg',
                    '/portfolio/guesthouse-castagnola/18.jpg',
                    '/portfolio/guesthouse-castagnola/19.jpg',
                    '/portfolio/guesthouse-castagnola/20.jpg',
                    '/portfolio/guesthouse-castagnola/21.jpg',
                    '/portfolio/guesthouse-castagnola/22.jpg',
                    '/portfolio/guesthouse-castagnola/23.jpg',
                    '/portfolio/guesthouse-castagnola/24.jpg',
                ],
            },
            {
                title: "Salotto Brè",
                place: "Brè, Lugano",
                category: "hotels",
                description: "Un rifugio pieno di carattere nel borgo di Brè sopra Lugano — fascino rustico ticinese e vista sul lago.",
                cover: '/portfolio/salotto-bre/1.jpg',
                photos: [
                    '/portfolio/salotto-bre/1.jpg',
                    '/portfolio/salotto-bre/2.jpg',
                    '/portfolio/salotto-bre/3.jpg',
                    '/portfolio/salotto-bre/4.jpg',
                    '/portfolio/salotto-bre/5.jpg',
                    '/portfolio/salotto-bre/6.jpg',
                    '/portfolio/salotto-bre/7.jpg',
                    '/portfolio/salotto-bre/8.jpg',
                    '/portfolio/salotto-bre/9.jpg',
                    '/portfolio/salotto-bre/10.jpg',
                    '/portfolio/salotto-bre/11.jpg',
                    '/portfolio/salotto-bre/12.jpg',
                    '/portfolio/salotto-bre/13.jpg',
                    '/portfolio/salotto-bre/14.jpg',
                    '/portfolio/salotto-bre/15.jpg',
                ],
            },
            {
                title: "Lugano",
                place: "Lugano, Svizzera",
                category: "tourism",
                description: "Contenuti tra Lugano e il Ticino — lungolaghi con palme, luce mediterranea e il ritmo lento del sud della Svizzera.",
                cover: '/portfolio/lugano-tourism/1.jpg',
                photos: [
                    '/portfolio/lugano-tourism/1.jpg',
                    '/portfolio/lugano-tourism/2.jpg',
                    '/portfolio/lugano-tourism/3.jpg',
                    '/portfolio/lugano-tourism/4.jpg',
                    '/portfolio/lugano-tourism/5.jpg',
                    '/portfolio/lugano-tourism/6.jpg',
                    '/portfolio/lugano-tourism/7.jpg',
                    '/portfolio/lugano-tourism/8.jpg',
                    '/portfolio/lugano-tourism/9.jpg',
                    '/portfolio/lugano-tourism/10.jpg',
                    '/portfolio/lugano-tourism/11.jpg',
                    '/portfolio/lugano-tourism/12.jpg',
                    '/portfolio/lugano-tourism/13.jpg',
                    '/portfolio/lugano-tourism/14.jpg',
                    '/portfolio/lugano-tourism/15.jpg',
                    '/portfolio/lugano-tourism/16.jpg',
                    '/portfolio/lugano-tourism/17.jpg',
                    '/portfolio/lugano-tourism/18.jpg',
                    '/portfolio/lugano-tourism/19.jpg',
                    '/portfolio/lugano-tourism/20.jpg',
                    '/portfolio/lugano-tourism/21.jpg',
                    '/portfolio/lugano-tourism/22.jpg',
                    '/portfolio/lugano-tourism/23.jpg',
                    '/portfolio/lugano-tourism/24.jpg',
                    '/portfolio/lugano-tourism/25.jpg',
                    '/portfolio/lugano-tourism/26.jpg',
                    '/portfolio/lugano-tourism/27.jpg',
                    '/portfolio/lugano-tourism/28.jpg',
                    '/portfolio/lugano-tourism/29.jpg',
                    '/portfolio/lugano-tourism/30.jpg',
                    '/portfolio/lugano-tourism/31.jpg',
                    '/portfolio/lugano-tourism/32.jpg',
                    '/portfolio/lugano-tourism/33.jpg',
                    '/portfolio/lugano-tourism/34.jpg',
                    '/portfolio/lugano-tourism/35.jpg',
                    '/portfolio/lugano-tourism/36.jpg',
                    '/portfolio/lugano-tourism/37.jpg',
                    '/portfolio/lugano-tourism/38.jpg',
                    '/portfolio/lugano-tourism/39.jpg',
                    '/portfolio/lugano-tourism/40.jpg',
                    '/portfolio/lugano-tourism/41.jpg',
                    '/portfolio/lugano-tourism/42.jpg',
                    '/portfolio/lugano-tourism/43.jpg',
                    '/portfolio/lugano-tourism/44.jpg',
                    '/portfolio/lugano-tourism/45.jpg',
                    '/portfolio/lugano-tourism/46.jpg',
                    '/portfolio/lugano-tourism/47.jpg',
                    '/portfolio/lugano-tourism/48.jpg',
                    '/portfolio/lugano-tourism/49.jpg',
                    '/portfolio/lugano-tourism/50.jpg',
                    '/portfolio/lugano-tourism/51.jpg',
                    '/portfolio/lugano-tourism/52.jpg',
                    '/portfolio/lugano-tourism/53.jpg',
                    '/portfolio/lugano-tourism/54.jpg',
                    '/portfolio/lugano-tourism/55.jpg',
                    '/portfolio/lugano-tourism/56.jpg',
                    '/portfolio/lugano-tourism/57.jpg',
                    '/portfolio/lugano-tourism/58.jpg',
                    '/portfolio/lugano-tourism/59.jpg',
                    '/portfolio/lugano-tourism/60.jpg',
                ],
            },
            {
                title: "Eiger Lodge",
                place: "Grindelwald, Svizzera",
                category: "hotels",
                description: "Lodge alpino di charme ai piedi dell’Eiger. Interni caldi, viste sulle montagne e luce mattutina silenziosa.",
                cover: '/portfolio/eiger-lodge/1.jpg',
                photos: [
                    '/portfolio/eiger-lodge/1.jpg',
                    '/portfolio/eiger-lodge/2.jpg',
                    '/portfolio/eiger-lodge/3.jpg',
                    '/portfolio/eiger-lodge/4.jpg',
                    '/portfolio/eiger-lodge/5.jpg',
                    '/portfolio/eiger-lodge/6.jpg',
                    '/portfolio/eiger-lodge/7.jpg',
                    '/portfolio/eiger-lodge/8.jpg',
                    '/portfolio/eiger-lodge/9.jpg',
                ],
            },
            {
                title: "Giardino Lago",
                place: "Locarno, Svizzera",
                category: "hotels",
                description: "Hotel boutique sul Lago Maggiore, luce sull’acqua e interni pensati per la calma.",
                cover: '/portfolio/giardino-lago/15.jpg',
                photos: [
                    '/portfolio/giardino-lago/1.jpg',
                    '/portfolio/giardino-lago/2.jpg',
                    '/portfolio/giardino-lago/3.jpg',
                    '/portfolio/giardino-lago/4.jpg',
                    '/portfolio/giardino-lago/5.jpg',
                    '/portfolio/giardino-lago/6.jpg',
                    '/portfolio/giardino-lago/7.jpg',
                    '/portfolio/giardino-lago/8.jpg',
                    '/portfolio/giardino-lago/9.jpg',
                    '/portfolio/giardino-lago/10.jpg',
                    '/portfolio/giardino-lago/11.jpg',
                    '/portfolio/giardino-lago/12.jpg',
                    '/portfolio/giardino-lago/13.jpg',
                    '/portfolio/giardino-lago/14.jpg',
                    '/portfolio/giardino-lago/15.jpg',
                    '/portfolio/giardino-lago/16.jpg',
                ],
            },
            {
                title: "Giardino Ascona",
                place: "Ascona, Svizzera",
                category: "hotels",
                description: "Classico Ascona, patio con ulivi, dettagli mediterranei e pomeriggi lenti.",
                cover: '/portfolio/giardino-ascona/1.jpg',
                photos: [
                    '/portfolio/giardino-ascona/1.jpg',
                    '/portfolio/giardino-ascona/2.jpg',
                    '/portfolio/giardino-ascona/3.jpg',
                    '/portfolio/giardino-ascona/4.jpg',
                    '/portfolio/giardino-ascona/5.jpg',
                    '/portfolio/giardino-ascona/6.jpg',
                    '/portfolio/giardino-ascona/7.jpg',
                    '/portfolio/giardino-ascona/8.jpg',
                    '/portfolio/giardino-ascona/9.jpg',
                    '/portfolio/giardino-ascona/10.jpg',
                    '/portfolio/giardino-ascona/11.jpg',
                    '/portfolio/giardino-ascona/12.jpg',
                    '/portfolio/giardino-ascona/13.jpg',
                ],
            },
            {
                title: "Lucerna",
                place: "Svizzera",
                category: "tourism",
                description: "Lucerna nella luce d'estate, il lago, i ponti di legno e le Alpi appena dietro.",
                cover: '/portfolio/lucerne/1.jpg',
                photos: [
                    '/portfolio/lucerne/1.jpg',
                    '/portfolio/lucerne/2.jpg',
                    '/portfolio/lucerne/3.jpg',
                    '/portfolio/lucerne/4.jpg',
                    '/portfolio/lucerne/5.jpg',
                    '/portfolio/lucerne/6.jpg',
                    '/portfolio/lucerne/7.jpg',
                    '/portfolio/lucerne/8.jpg',
                ],
            },
            {
                title: "Kulturhof Hinter Musegg",
                place: "Lucerna, Svizzera",
                category: "tourism",
                description: "Servizio nello storico Kulturhof Hinter Musegg, atmosfera, dettagli e luce naturale.",
                cover: '/portfolio/kulturhof/1.jpg',
                photos: [
                    '/portfolio/kulturhof/1.jpg',
                    '/portfolio/kulturhof/2.jpg',
                    '/portfolio/kulturhof/3.jpg',
                    '/portfolio/kulturhof/4.jpg',
                    '/portfolio/kulturhof/5.jpg',
                    '/portfolio/kulturhof/6.jpg',
                    '/portfolio/kulturhof/7.jpg',
                    '/portfolio/kulturhof/8.jpg',
                    '/portfolio/kulturhof/9.jpg',
                    '/portfolio/kulturhof/10.jpg',
                    '/portfolio/kulturhof/11.jpg',
                    '/portfolio/kulturhof/12.jpg',
                ],
            },
            {
                title: "Ascona",
                place: "Ticino, Svizzera",
                category: "tourism",
                description: "Le vie del centro di Ascona sul Lago Maggiore, colori pastello e il sapore di un’estate ticinese.",
                cover: '/portfolio/ascona/1.jpg',
                photos: [
                    '/portfolio/ascona/1.jpg',
                    '/portfolio/ascona/2.jpg',
                    '/portfolio/ascona/3.jpg',
                    '/portfolio/ascona/4.jpg',
                    '/portfolio/ascona/5.jpg',
                    '/portfolio/ascona/6.jpg',
                    '/portfolio/ascona/7.jpg',
                    '/portfolio/ascona/8.jpg',
                    '/portfolio/ascona/9.jpg',
                    '/portfolio/ascona/10.jpg',
                    '/portfolio/ascona/11.jpg',
                    '/portfolio/ascona/12.jpg',
                ],
            },
            {
                title: "Locarno",
                place: "Ticino, Svizzera",
                category: "tourism",
                description: "Locarno nella luce d’estate, Piazza Grande, il lago e l’atmosfera del sud della Svizzera.",
                cover: '/portfolio/locarno/1.jpg',
                photos: [
                    '/portfolio/locarno/1.jpg',
                    '/portfolio/locarno/2.jpg',
                    '/portfolio/locarno/3.jpg',
                    '/portfolio/locarno/4.jpg',
                    '/portfolio/locarno/5.jpg',
                    '/portfolio/locarno/6.jpg',
                    '/portfolio/locarno/7.jpg',
                    '/portfolio/locarno/8.jpg',
                ],
            },
            {
                title: "Jungfraujoch",
                place: "Oberland Bernese",
                category: "tourism",
                description: "Top of Europe. Ghiacciai, tunnel di ghiaccio e il bianco silenzio sopra le nuvole.",
                cover: '/portfolio/jungfraujoch/1.jpg',
                photos: [
                    '/portfolio/jungfraujoch/1.jpg',
                    '/portfolio/jungfraujoch/2.jpg',
                    '/portfolio/jungfraujoch/3.jpg',
                    '/portfolio/jungfraujoch/4.jpg',
                    '/portfolio/jungfraujoch/5.jpg',
                    '/portfolio/jungfraujoch/6.jpg',
                    '/portfolio/jungfraujoch/7.jpg',
                    '/portfolio/jungfraujoch/8.jpg',
                    '/portfolio/jungfraujoch/9.jpg',
                ],
            },
            {
                title: "Harder Kulm",
                place: "Oberland Bernese",
                category: "tourism",
                description: "Punto panoramico sopra Interlaken, vista sull’Eiger, il Mönch e la Jungfrau.",
                cover: '/portfolio/harder-kulm/1.jpg',
                photos: [
                    '/portfolio/harder-kulm/1.jpg',
                    '/portfolio/harder-kulm/2.jpg',
                    '/portfolio/harder-kulm/3.jpg',
                    '/portfolio/harder-kulm/4.jpg',
                    '/portfolio/harder-kulm/5.jpg',
                    '/portfolio/harder-kulm/6.jpg',
                    '/portfolio/harder-kulm/7.jpg',
                    '/portfolio/harder-kulm/8.jpg',
                ],
            },
            {
                title: "Grindelwald First",
                place: "Oberland Bernese",
                category: "tourism",
                description: "Sulle Alpi Bernesi, sentieri, funivia e panorami che ti fanno fermare un attimo.",
                cover: '/portfolio/grindelwald-first/1.jpg',
                photos: [
                    '/portfolio/grindelwald-first/1.jpg',
                    '/portfolio/grindelwald-first/2.jpg',
                    '/portfolio/grindelwald-first/3.jpg',
                    '/portfolio/grindelwald-first/4.jpg',
                ],
            },
            {
                title: "Berna",
                place: "Svizzera",
                category: "tourism",
                description: "La capitale svizzera nella luce d’autunno, i portici, l’Aar e i vicoli con atmosfera.",
                cover: '/portfolio/bern/1.jpg',
                photos: [
                    '/portfolio/bern/1.jpg',
                    '/portfolio/bern/2.jpg',
                    '/portfolio/bern/3.jpg',
                    '/portfolio/bern/4.jpg',
                    '/portfolio/bern/5.jpg',
                    '/portfolio/bern/6.jpg',
                    '/portfolio/bern/7.jpg',
                    '/portfolio/bern/8.jpg',
                    '/portfolio/bern/9.jpg',
                    '/portfolio/bern/10.jpg',
                    '/portfolio/bern/11.jpg',
                    '/portfolio/bern/12.jpg',
                ],
            },
            {
                title: "Algarve",
                place: "Portogallo",
                category: "tourism",
                description: "Scogliere, oceano e la luce della costa dell’Algarve, inquadrati come una cartolina.",
                cover: '/portfolio/algarve/1.jpg',
                photos: [
                    '/portfolio/algarve/1.jpg',
                    '/portfolio/algarve/2.jpg',
                    '/portfolio/algarve/3.jpg',
                    '/portfolio/algarve/4.jpg',
                    '/portfolio/algarve/5.jpg',
                    '/portfolio/algarve/6.jpg',
                    '/portfolio/algarve/7.jpg',
                    '/portfolio/algarve/8.jpg',
                ],
            },
            {
                title: "Veoli Botanica",
                place: "Servizio prodotto",
                category: "products",
                description: "Servizio per il brand polacco di skincare botanica Veoli, palette naturale e inquadrature pulite.",
                cover: '/portfolio/veoli-botanica/1.jpg',
                photos: [
                    '/portfolio/veoli-botanica/1.jpg',
                    '/portfolio/veoli-botanica/2.jpg',
                    '/portfolio/veoli-botanica/3.jpg',
                    '/portfolio/veoli-botanica/4.jpg',
                    '/portfolio/veoli-botanica/5.jpg',
                    '/portfolio/veoli-botanica/6.jpg',
                    '/portfolio/veoli-botanica/7.jpg',
                    '/portfolio/veoli-botanica/8.jpg',
                ],
            },
            {
                title: "Emu",
                place: "Servizio prodotto",
                category: "products",
                description: "Servizio prodotto per Emu. Luce pulita, toni caldi e scatti che lasciano parlare il prodotto.",
                cover: '/portfolio/emu/1.jpg',
                photos: [
                    '/portfolio/emu/1.jpg',
                    '/portfolio/emu/2.jpg',
                    '/portfolio/emu/3.jpg',
                    '/portfolio/emu/4.jpg',
                    '/portfolio/emu/5.jpg',
                    '/portfolio/emu/6.jpg',
                    '/portfolio/emu/7.jpg',
                    '/portfolio/emu/8.jpg',
                    '/portfolio/emu/9.jpg',
                    '/portfolio/emu/10.jpg',
                    '/portfolio/emu/11.jpg',
                ],
            },
            {
                title: "So Bloomy",
                place: "Servizio prodotto",
                category: "products",
                description: "Servizio prodotto per So Bloomy. Palette d’autunno, luce calda e scatti che costruiscono il mood del brand.",
                cover: '/portfolio/autumn-product/6.jpg',
                photos: [
                    '/portfolio/autumn-product/1.jpg',
                    '/portfolio/autumn-product/2.jpg',
                    '/portfolio/autumn-product/3.jpg',
                    '/portfolio/autumn-product/4.jpg',
                    '/portfolio/autumn-product/5.jpg',
                    '/portfolio/autumn-product/6.jpg',
                    '/portfolio/autumn-product/7.jpg',
                    '/portfolio/autumn-product/8.jpg',
                ],
            },
            {
                title: "Dilmah",
                place: "Servizio prodotto",
                category: "products",
                description: "Servizio prodotto natalizio per Dilmah. Luce calda, atmosfera e dettagli per brand di hospitality e lifestyle.",
                cover: '/portfolio/christmas/2.jpg',
                photos: [
                    '/portfolio/christmas/1.jpg',
                    '/portfolio/christmas/2.jpg',
                    '/portfolio/christmas/3.jpg',
                    '/portfolio/christmas/4.jpg',
                    '/portfolio/christmas/5.jpg',
                    '/portfolio/christmas/6.jpg',
                    '/portfolio/christmas/7.jpg',
                    '/portfolio/christmas/8.jpg',
                ],
            },
            {
                title: "Big Active",
                place: "Servizio prodotto",
                category: "products",
                description: "Servizio per Big Active. Tè in una composizione calda, mood direttamente dalla foglia.",
                cover: '/portfolio/tea-product/1.jpg',
                photos: [
                    '/portfolio/tea-product/1.jpg',
                    '/portfolio/tea-product/2.jpg',
                    '/portfolio/tea-product/3.jpg',
                    '/portfolio/tea-product/4.jpg',
                    '/portfolio/tea-product/5.jpg',
                    '/portfolio/tea-product/6.jpg',
                    '/portfolio/tea-product/7.jpg',
                    '/portfolio/tea-product/8.jpg',
                ],
            },
        ],
    },
    brands: {
        label: 'CON CHI HO LAVORATO',
        items: [
            { name: 'Jungfrau Region' },
            { name: 'Taksidi' },
            { name: 'Canon' },
            { name: 'Lucerne Tourism' },
            { name: 'Titlis' },
            { name: 'Grindelwald First' },
            { name: 'Jungfraujoch' },
            { name: 'Eiger Lodge' },
            { name: 'Adelboden-Lenk-Kandersteg' },
            { name: 'Zentralbahn' },
            { name: 'Lake Lucerne' },
            { name: 'Tara Style' },
            { name: 'Dilmah' },
            { name: 'Everest Outdoor' },
            { name: 'Emu Australia' },
            { name: 'Krups' },
        ],
    },
    faq: {
        label: "FAQ",
        title: "Domande frequenti.",
        items: [
            { q: "Quanto costa un servizio di content creation in Svizzera?",
                a: "Il prezzo dipende interamente dalla portata e dallo scope del progetto: un singolo set fotografico, un pacchetto reel completo o la gestione end-to-end dei social hanno tariffe diverse. Ogni offerta la costruisco sulle reali esigenze del brand, quindi sono sempre felice di preparare un preventivo su misura." },
            { q: "Cosa è incluso in un pacchetto di content creation?",
                a: "La maggior parte dei progetti include l'intero processo creativo: pianificazione del mood e dell'angolo, fotografia, short-form video dove ha senso, editing e consegna finale, da usare sui tuoi canali. A seconda del pacchetto possiamo anche co-pubblicare su {'@'}travellingdominika." },
            { q: "Viaggi per i servizi?",
                a: "Sì, ovunque in Svizzera, e prendo anche progetti in altri paesi. I costi di trasferta per località più lontane sono inclusi in modo trasparente nel preventivo." },
            { q: "Qual è la differenza tra content creation e social media management?",
                a: "Content creation significa che creo le foto, i reel e i contenuti di storytelling, e tu li pubblichi sui tuoi canali. Social media management significa che gestisco i tuoi profili end-to-end: pianificazione, pubblicazione, caption, gestione messaggi, tutto su Instagram, Facebook, LinkedIn o TikTok." },
            { q: "Quanto dura un servizio in hotel o ristorante?",
                a: "Mezza giornata sul posto è sufficiente per la maggior parte dei boutique hotel e ristoranti. Strutture più grandi o servizi con tanti deliverable richiedono di solito un'intera giornata o due. Editing e consegna seguono in una o due settimane." },
            { q: "Posso usare le foto e i reel sui miei canali?",
                a: "Sì. I pacchetti foto e reel includono i diritti d'uso per i canali del tuo brand, il sito e i materiali marketing. Eventuali esclusive o utilizzi in advertising a pagamento si concordano in anticipo." },
            { q: "Produci anche short-form video, Reels e contenuti TikTok?",
                a: "Sì, lo short-form video è una parte centrale del mio lavoro. I pacchetti reel includono pezzi da 30 a 45 secondi, e posso anche costruire una cadenza ricorrente di reel settimanali o mensili insieme alle foto." },
            { q: "Lavori anche con ristoranti, enti turistici e brand di prodotto?",
                a: "Sì. La maggior parte del mio lavoro è con hotel e hospitality, ma creo contenuti anche per regioni turistiche, ristoranti e caffetterie, attività locali e brand di prodotto. Tra i clienti recenti per il prodotto: Veoli Botanica, So Bloomy, Dilmah e Big Active." },
            { q: "Con quanto anticipo conviene prenotare?",
                a: "Da due a quattro settimane di anticipo sono l'ideale per pianificare bene mood, location e tempi. Nei periodi di alta stagione come estate in Ticino o inverno nell'Oberland Bernese conviene prenotare ancora prima." },
        ],
    },
    seo: {
        home: {
            title: "Content creator per hotel e turismo in Svizzera",
            description: "Sono Dominika, content creator e fotografa con base in Svizzera. Lavoro con hotel, turismo e brand. Fotografia, reel, social.",
        },
        portfolio: {
            title: "Portfolio · Fotografia per hotel, turismo e prodotti in Svizzera",
            description: "Selezione di lavori fotografici e di contenuto da tutta la Svizzera: hotel, turismo e servizi prodotto.",
        },
        hotels: {
            title: "Content creator per hotel in Svizzera · Portfolio",
            description: "Servizi e collaborazioni con hotel in tutta la Svizzera. Fotografia di hospitality di charme.",
        },
        tourism: {
            title: "Fotografia turistica e di viaggio in Svizzera · Portfolio",
            description: "Contenuti di turismo e viaggio da tutta la Svizzera: Ticino, Lucerna, Oberland Bernese e oltre.",
        },
        products: {
            title: "Fotografia di prodotto e brand content · Portfolio",
            description: "Servizi prodotto per brand skincare, food e lifestyle. Tra i clienti recenti: Veoli Botanica, So Bloomy, Dilmah e Big Active.",
        },
        privacy: {
            title: "Informativa sulla privacy",
            description: "Come travellingdominika.com tratta i tuoi dati: niente cookie, nessun tracciamento, nessuna analisi.",
        },
    },
    contact: {
        label: 'CONTATTI',
        title: 'Scopri cosa posso fare per te.',
        sub: 'Scrivimi, risponderò volentieri a ogni messaggio.',
        email: "dominikatrunowicz{'@'}gmail.com",
        cta: 'Scrivimi',
    },
    privacy: {
        label: 'PRIVACY',
        title: 'Informativa sulla privacy',
        updated: 'Ultimo aggiornamento: giugno 2026',
        intro: 'Questo sito è il mio portfolio personale. Lo tengo semplice e raccolgo il meno possibile — ecco cosa significa in pratica.',
        sections: [
            {
                heading: 'Niente cookie, nessun tracciamento',
                body: 'travellingdominika.com non usa cookie, analisi o tracciamenti di terze parti. Nulla della tua visita viene memorizzato o profilato.',
            },
            {
                heading: 'Hosting',
                body: "Il sito è servito come file statici tramite Cloudflare, che può trattare dati tecnici di base della richiesta (come il tuo indirizzo IP) per fornire le pagine e proteggere da abusi. Per i dettagli consulta l'informativa sulla privacy di Cloudflare.",
            },
            {
                heading: 'Contatto via email',
                body: 'Se mi scrivi, uso il tuo messaggio e il tuo indirizzo solo per risponderti. Non ti aggiungo a nessuna lista e non condivido i tuoi dati con nessuno.',
            },
            {
                heading: 'Link ai social',
                body: 'I link a Instagram e LinkedIn ti portano a quelle piattaforme, che hanno le proprie informative sulla privacy.',
            },
            {
                heading: 'Domande',
                body: 'Domande sui tuoi dati? Scrivimi:',
            },
        ],
    },
    footer: {
        contactLabel: 'CONTATTI',
        email: "dominikatrunowicz{'@'}gmail.com",
        responseTime: 'Rispondo entro 24h.',
        socialLabel: 'SOCIAL',
        instagramLabel: 'Instagram',
        instagramUrl: 'https://instagram.com/travellingdominika',
        linkedinLabel: 'LinkedIn',
        linkedinUrl: 'https://www.linkedin.com/in/dominika-trunowicz-317403274/',
        copyright: '© 2026 travellingdominika',
        privacy: 'Privacy Policy',
        privacyUrl: '#privacy',
    },
};
